import { createSelector } from './selectorWrapper'
import { simpleSelectors } from './basicState'
import { ICollection, sanitizeCollections } from './collections'
import { TitleIdToCarousel } from '../reducers/carousel'

export type ISanitizedCarousel = (ICollection | null)[]

export const sanitizedCarouselsSelector = createSelector(
  simpleSelectors.pageTitleId,
  simpleSelectors.carousel,
  (
    pageTitleID: string,
    titleIdToCarousel: TitleIdToCarousel
  ): ISanitizedCarousel => {
    return sanitizeCollections(titleIdToCarousel[pageTitleID])
  }
)

export const showCarouselsSelector = createSelector(
  sanitizedCarouselsSelector,
  (
    carousels: ISanitizedCarousel,
  ): boolean => Boolean(carousels && carousels.length)
)
